import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { LogItem } from "@/Administration/Models/Log/LogItem";
import { LogItemList } from "@/Administration/Models/Log/LogItemList";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";

class AdministrationLogResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);
        this.RegisterOperation(ServerOperations.Server.Myle_LoadAdminLogData, this.loadAdminLogData);
    }

    private async loadAdminLogData(response: ServerEvent, store: AdministrationStore): Promise<void> {
        if (response.Errors.length > 0) {
            sessionStore.showPopup(response.Errors);
        }

        const tableItems: LogItem[] = [];
        if (response.Data.Results) {
            for (const logItem of response.Data.Results) {
                const itemModel: LogItem = new LogItem();
                itemModel.Id = logItem.Id;
                itemModel.IP = logItem.IP;
                itemModel.EncounterId = logItem.EncounterId;
                itemModel.Action = AdministrationHelper.convertEventTypeEnumToString(logItem.EventType);
                itemModel.Date = logItem.EventDate;
                itemModel.PatientId = logItem.PatientContactId;
                itemModel.Pseudonym = (logItem.Pseudonym && logItem.Pseudonym.length > 0) ? logItem.Pseudonym : "--";
                itemModel.Description = await AdministrationHelper.getFormattedLogItemDescription(logItem.Description, logItem.EventType);
                itemModel.EventType = logItem.EventType;

                AdministrationHelper.populateEmployeeDetails(itemModel, logItem.EmployeeContactId);
                tableItems.push(itemModel);
            }
        }

        store.logTabModel = store.logTabModel
            .set("TableData", tableItems.map(item => new LogItemList(item)).toImmutable())
            .set("TotalQueryPages", response.Data.TotalQueryPages)
            .set("TotalQueryRows", response.Data.TotalQueryRows)
            .set("CurrentPage", response.Data.CurrentPage);

        store.EmitChangeToListeners();
    }
}

export { AdministrationLogResponseHandler };
